import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allFeatureRoutes } from '@/pages/feature/routes';

export const featureRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.feature, action: PermissionAction.enum.view },
  },
  children: [
    ...allFeatureRoutes,
  ],
};
